import * as React from "react";
import RequireRole from "modules/common/components/requireRole";
import { UserRoleStrings } from "modules/authorization/models";
import DashboardTile from "./dashboardTile";
import { injectIntl, IntlShape } from "react-intl";
import AnalyticsErrorBanner from "modules/common/components/analyticsErrorBanner";
import { connect, ConnectedProps } from "react-redux"
import { GlobalApplicationState } from "globalApplicationState";
import { ViewCarouselOutlined } from "@mui/icons-material";
import { TextsmsOutlined } from "@mui/icons-material";

class Dashboard extends React.Component<PropsWithRedux, ComponentState> {
    public render() {
        const formatMessage = this.props.intl.formatMessage;
        return (
            <div className="dashboard">
                {this.props.bannerMessage &&
                    <span>
                        <AnalyticsErrorBanner mssg={this.props.bannerMessage} />
                        <div className="clearfix" />
                    </span>
                }
                <div className="dashboard-tiles">
                    <RequireRole roleName={UserRoleStrings.AUTHOR}>
                        <DashboardTile materialIconName="description"
                            materialIconColor="#0247bf"
                            actionText={formatMessage({ id: "posts.posts" })}
                            linkTo="~/admin/posts" />
                    </RequireRole>
                    {this.props.eventsEnabled &&
                        <RequireRole roleName={UserRoleStrings.AUTHOR}>
                            <DashboardTile materialIconName="calendar_today"
                                materialIconColor="#c48b3b"
                                actionText={formatMessage({ id: "events.events" })}
                                linkTo="~/admin/events" />
                        </RequireRole>
                    }
                    <RequireRole roleName={UserRoleStrings.AUTHOR}>
                        <DashboardTile materialIconName="assignment_turned_in"
                            materialIconColor="#599fa0"
                            actionText={formatMessage({ id: "surveys.surveys" })}
                            linkTo="~/admin/surveys" />
                    </RequireRole>
                    {this.props.showFeatures && this.props.showFeatures.documentsEnabled &&
                        <RequireRole roleName={UserRoleStrings.AUTHOR}>
                            <DashboardTile materialIconName="assignment"
                                materialIconColor="#3b6531"
                                actionText="Documents"
                                linkTo="~/admin/documents" />
                        </RequireRole>
                    }
                    {this.props.shortcutsEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile materialIconName="link"
                                materialIconColor="#ad392f"
                                actionText="Shortcuts"
                                linkTo="~/admin/shortcuts" />
                        </RequireRole>
                    }
                    {this.props.showFeatures && this.props.showFeatures.audiences &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile materialIconName="supervisor_account"
                                materialIconColor="#e1cca9"
                                actionText={formatMessage({ id: "audiences.audiences" })}
                                linkTo="~/admin/audiences" />
                        </RequireRole>
                    }
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="class"
                            materialIconColor="#453a6e"
                            actionText="Topics (Posts & Events)"
                            linkTo="~/admin/topics" />
                    </RequireRole>
                    {this.props.showFeatures && this.props.showFeatures.categoryTagsEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile materialIconName="local_offer"
                                materialIconColor="#b291ba"
                                actionText="Category Tags (Others)"
                                linkTo="~/admin/categoryTags" />
                        </RequireRole>
                    }
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="send"
                            materialIconColor="#69a2d1"
                            actionText={formatMessage({ id: "messaging.directMessaging" })}
                            linkTo="~/admin/messaging" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="newspaper"
                            materialIconColor="#897d6c"
                            actionText={formatMessage({ id: "messaging.newsletters" })}
                            linkTo="~/admin/newsletters" />
                    </RequireRole>
                    {
                        this.props.showFeatures && this.props.showFeatures.emailManagementEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile 
                                materialIconName="email"
                                materialIconColor="#599fa0"
                                actionText={formatMessage({ id: "messaging.emails" })}
                                linkTo="~/admin/emails" 
                            />
                        </RequireRole>
                    }
                    {
                        this.props.showFeatures && this.props.showFeatures.smsManagementEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile 
                                icon={<TextsmsOutlined htmlColor="#3b6531" style={{ fontSize: 104 }} />}
                                actionText={formatMessage({ id: "messaging.sms" })}
                                linkTo="~/admin/sms" 
                            />
                        </RequireRole>
                    }
                    {this.props.showFeatures && this.props.showFeatures.portalPagesEnabled && this.props.portalPagesEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile materialIconName="menu_book"
                                materialIconColor="#ad392f"
                                actionText="Portal Pages"
                                linkTo="~/admin/portalPages" />
                        </RequireRole>
                    }
                    {this.props.showFeatures && this.props.showFeatures.homeScreenConfigEnabled &&
                        <RequireRole roleName={UserRoleStrings.OWNER}>
                            <DashboardTile
                                icon={<ViewCarouselOutlined htmlColor="#d0a369" style={{ fontSize: 104 }} />}
                                actionText="Home Screens"
                                linkTo="~/admin/homeScreens"
                            />
                        </RequireRole>}
                    <RequireRole roleName={UserRoleStrings.AUTHOR}>
                        <DashboardTile materialIconName="photo_library"
                            materialIconColor="#395e9e"
                            actionText="Media Gallery"
                            linkTo="~/admin/gallery" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="history"
                            materialIconColor="#f5bf42"
                            actionText="Activity Tools"
                            linkTo="~/admin/activity" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="insert_chart"
                            materialIconColor="#81cc78"
                            actionText="Platform Analytics"
                            linkTo="~/admin/insights" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="account_circle"
                            materialIconColor="#ad5774"
                            actionText="Users & Permissions"
                            linkTo="~/admin/users" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.OWNER}>
                        <DashboardTile materialIconName="settings"
                            materialIconColor="#adb7c1"
                            actionText="Tenant Configurations"
                            linkTo="~/admin/settings" />
                    </RequireRole>
                    <RequireRole roleName={UserRoleStrings.SPARROW_SUPER_ADMIN}>
                        <DashboardTile materialIconName="admin_panel_settings"
                            materialIconColor="#ad392f"
                            actionText="Tenant Management"
                            linkTo="~/admin/tenantManagement" />
                    </RequireRole>
                </div>

            </div>
        );
    }
}


interface ComponentProps {
    intl: IntlShape;
}

interface ComponentState {
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        androidAppUrl: state.settings.tenantSettings.androidAppUrl,
        bannerMessage: state.settings.tenantSettings.bannerMessage,
        documentsEnabled: state.settings.tenantSettings.showFeatures.documentsEnabled && state.settings.tenantSettings.documentsEnabled,
        eventsEnabled: state.settings.tenantSettings.mobileEventsEnabled,
        iosAppUrl: state.settings.tenantSettings.iosAppUrl,
        showFeatures: state.settings.tenantSettings.showFeatures,
        portalPagesEnabled: state.settings.tenantSettings.showFeatures.portalPagesEnabled && state.settings.tenantSettings.portalPagesEnabled,
        shortcutsEnabled: state.settings.tenantSettings.shortcutsEnabled
    })
);
type PropsWithRedux = ConnectedProps<typeof connector>;

export default injectIntl(connector(Dashboard))
